import React from "react";
import { Link } from "react-router-dom";

const NavButton = (props) => (
  <div className="home-navigation-button">
    <div className="image-container">
      <img alt={props.title} src={props.imagesrc} />
    </div>
    <Link to={props.link}>
      <button
        className={"btn " + (props.isPrimary ? "btn-primary" : "btn-default")}
      >
        {props.title}
      </button>
    </Link>
  </div>
);

export default NavButton;
